import { useEffect, useState } from 'react';

import { vehicleHistoryAction } from '@core/Actions/VehicleHistory/VehicleHistory.action';
import { addToReportsRequestedAtom } from '@core/Atoms/HistoryCheck/HistoryCheck.atom';
import { Locale } from '@core/Entities/Locale/Locale.entity';
import Button from '@gds/Button/Button';
import { StatusDisplay } from '@shared-components/StatusDisplay/StatusDisplay';
import { useSetAtom } from 'jotai';

import { openMessageDealerModalAtom } from 'Atoms/App/Pdp/OpenMessageDealerModal.atom';

import { LeadForm } from '../LeadForm/LeadForm';
import { StringsType } from '../LeadForm/LeadForm.entity';

import styles from './HistoryCheck.module.css';

interface Props {
  locale: Locale;
  strings: StringsType;
  regNumber: string;
  reportRequested: boolean;
}
const HistoryCheckModal = ({ locale, strings, regNumber, reportRequested }: Props) => {
  const [isLoading, setIsLoading] = useState(!reportRequested ?? true);
  const setOpenMessageDealerModal = useSetAtom(openMessageDealerModalAtom);
  const [hasReport, setHasReport] = useState<boolean | undefined>(reportRequested);
  const addToReports = useSetAtom(addToReportsRequestedAtom);

  const fetchVehicleHistory = async () => {
    try {
      const res = await vehicleHistoryAction(regNumber);

      if (res.error) {
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setHasReport(true);
        addToReports({
          [`${regNumber}`]: { email: null },
        });
      }
    } catch (error) {
      setHasReport(false);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    regNumber && !hasReport && fetchVehicleHistory();
  }, []);

  const handleClick = () => {
    setOpenMessageDealerModal(locale);
  };

  if (!hasReport || isLoading) {
    const msgs = {
      headline: isLoading ? '' : strings.reportNotAvailable,
      description: isLoading ? '' : strings.contactDealerForInfo,
    };
    return (
      <div className={styles.reportStatusWrapper}>
        <StatusDisplay messages={msgs} type={isLoading ? 'loading' : 'error'} />
        {!isLoading && <Button onClick={() => handleClick()}>{strings.sendMessage}</Button>}
      </div>
    );
  }
  return (
    <>
      <div className={styles.callhistoryCheckModalWrapper}>
        <LeadForm strings={strings} locale={locale} />
      </div>
    </>
  );
};
export { HistoryCheckModal };
